import { useEffect, useRef, useState } from "preact/hooks";
import useSlider from "react-use/lib/useSlider";
import { pick } from "lodash-es";
import { useTranslator } from "@brickme/frontend-common/src/i18n/translation.tsx";
import initialImage from "./parrot-bw.png?format=webp&w=432&h=288&as=metadata";
import afterImage from "./parrot-colour.png?format=webp&w=432&h=288&as=metadata";
import HandIcon from "./hand-icon.tsx";
import classes from "./comparison-image.module.css";

function ComparisonImage() {
	const imageRef = useRef<HTMLDivElement>(null);
	// preact/react interop issue
	const { isSliding, value: sliderValue } = useSlider(imageRef as any);
	const t = useTranslator();

	// No way to give useSlider a default value (it's set to 0)
	const [hasStartedSliding, setStartedSliding] = useState(false);
	useEffect(() => {
		if (isSliding && !hasStartedSliding) {
			setStartedSliding(true);
		}
	}, [isSliding, hasStartedSliding]);
	const position = hasStartedSliding ? sliderValue : 0.5;

	return (
		<div
			ref={imageRef}
			className={classes["comparison-image"]}
			style={{
				"--position": `${Math.round(position * 100)}%`,
			}}
		>
			<button
				type="button"
				className={classes["comparison-image-slider-handle"]}
			>
				<HandIcon />
			</button>
			<div className={classes["images-container"]}>
				<div className={classes["before-image"]}>
					<img
						{...pick(initialImage, "src", "width", "height")}
						alt={t("Initial image")}
					/>
				</div>
				<div className={classes["after-image"]}>
					<div className={classes["after-image-inner"]}>
						<img
							{...pick(afterImage, "src", "width", "height")}
							alt={t("Image with color")}
						/>
					</div>
				</div>
				<div className={classes["comparison-image-slider-track"]} />
			</div>
		</div>
	);
}

export default ComparisonImage;
